// salessstatus


import { Trans } from '@lingui/macro';
import React from 'react';

export enum SALESTATUS {
    CREDIT = 'CREDIT',
    ADVANCE = 'ADVANCE',
    SALE = 'SALE',
}


export const getSalesTransStatus = (status: string) => {
    switch (status) {
        case 'CREDIT':
            return <Trans>Credit</Trans>
        case 'ADVANCE':
            return ( <Trans>Prepayment</Trans> )
        case 'SALE':
            return ( <Trans>Sale</Trans> )
        default   :
            return status

    }
}
